<template>
  <svg width="24" height="24" viewBox="0 0 24 24">
    <path
      d="m13.57 12.01-5.934 6.021a1.127 1.127 0 0 0 0 1.583c.43.435 1.13.44 1.566.011l5.938-6.023 1.574-1.592-1.568-1.597L9.19 4.376a1.11 1.11 0 0 0-1.57-.01 1.133 1.133 0 0 0-.01 1.596l5.96 6.048z"
      :fill="disabled ? '#ccccc9' : '#737380'"
      fill-rule="evenodd"
    />
  </svg>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
